// ** Initial State
const initialState = {
  data: [],
  total: 1,
  from: 0,
  to: 0,
  params: {},
  selectedData: null
}

const globalConfigs = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA_GLOBAL_CONFIG':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        from: action.from,
        to: action.to,
      }
    case 'GET_GLOBAL_CONFIG':
      return { ...state, selectedData: action.selectedData }
    case 'ADD_GLOBAL_CONFIG':
      return { ...state }
    case 'EDIT_GLOBAL_CONFIG':
      return { ...state }
    case 'DELETE_GLOBAL_CONFIG':
      return { ...state }
    default:
      return { ...state }
  }
}
export default globalConfigs
